export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";